export const RequisitionTypeValue = Object.freeze({
	APPOINTMENT: 1,
	IMAGIOLOGY: 2,
	CLINICAL_ANALYSIS: 3,
	PHYSIOTHERAPY: 4,
	SURGERY: 5,
	NON_SURGICAL: 6,
	OTHER_MCDTS: 7,
	DENTIST: 8,
	NURSING: 9,
	PATHOLOGIC_ANATOMY: 10,
	MEDICATION: 11,
	RELAPSE: 12,
	TRANSFER: 13,
	TRANSPORT: 17,
})
